<template>
  <div>
    <b-overlay
      :show="isLoading || isLoadingData || isLoadingForm"
      rounded="sm"
    >
      <div
        class="m-0 text-center"
        v-if="!isLoading"
      >
        <div v-if="formData != null">
          <EmployeeApprovalForm
            heightData="height: calc(100vh - 310px);"
            :form="formData"
            :isLoading="isLoadingForm"
            :isDisabled="isDisabled"
            :selectedLanguage="selectedLanguage"
          />
          <b-row class="mt-3">
            <b-col
              cols="6"
              class="text-left"
            >
              <a
                v-if="form.formSection.length"
                href="#"
                class="btn btn-warning"
                v-scroll-to="{ el: '#scrollspy', container: '#scrollspy', duration: 300, easing: 'linear', force: true, x: false, y: true }"
              >
                <font-awesome-icon icon="angle-up" />
              </a>
            </b-col>
            <b-col>
              <div class="float-right">
                <b-button
                  class="mr-2"
                  @click="onValidateSubmit"
                  variant="outline-success"
                >{{$t('updateBtn')}}</b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- review modal -->
        <b-modal
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
          id="modal-1"
          modal-header-close="No"
          :ok-title="$t('updateBtn')"
          :cancel-title="$t('cancelBtnText')"
          hide-header-close
          no-close-on-esc
          no-close-on-backdrop
          :title="$t('approvals.updateModalTitle')"
          @ok="onSubmit"
        >
          <p>{{ $t("approvalFormUpdatingMessage") }}</p>
          <p></p>
        </b-modal>

        <b-modal
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          id="modal-2"
          :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
          modal-header-close="No"
          ok-only
          :ok-title="$t('closeBtnText')"
          hide-header-close
          no-close-on-esc
          no-close-on-backdrop
          :title="$t('questionnaires.formUpdatedModalTitle')"
          @ok="$router.replace((isDirectAddApprovalLink) ? '/dashboard' : '/employee-approvals')"
        >
          <p>{{ $t("formUpdatedMessage") }}</p>
          <p></p>
        </b-modal>

        <b-alert
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          :content-class="$store.state.rightAlign ? 'text-right' : 'text-left'"
          v-model="showErrorToast"
          class="position-fixed fixed-top m-0 rounded-0"
          style="z-index: 2000"
          variant="danger"
          dismissible
          solid
        >{{ $t("formValidationMessage") }}</b-alert>

        <b-modal
          id="modal-leave"
          modal-header-close="No"
          :ok-title="$t('closeBtnText')"
          :cancel-title="$t('cancelBtnText')"
          hide-header-close
          no-close-on-esc
          no-close-on-backdrop
          :title="$t('toast.title')"
          @ok="leaveConfirm = true"
        >
          <p>{{ $t("formLeaveAlertMessage") }}</p>
          <p></p>
        </b-modal>
      </div>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import config from "../../configs/config";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import SectionContainer from "../../containers/SectionUserContainer";
import EmployeeApprovalForm from "./employeeApprovalForm";
// import AppLoader from "../../components/Loader/Loader";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../utils/HTTP";
import _ from "lodash";
import { Helper } from "@/helpers";
// import { parse } from 'vue-currency-input';
import uid from "uid";

export default {
  name: "employeeApprovalFormUpdate",
  components: {
    EmployeeApprovalForm,
    SectionContainer,
    // AppLoader,
  },
  data () {
    return {
      isLoadingData: false,
      // form: null,
      selectForm: {
        approvalType: null,
        amount: null,
        approvalStatus: null
      },
      approvalTypesOptions: [],
      formSchema: null,
      enabled: true,
      dragging: false,
      selected: "english",
      isInvalid: false,
      pageIntroText: "",
      showingIntro: true,
      showErrorToast: false,
      currentSectionIndex: 0,
      taskStatus: null,
      userConsent: 0,
      taskAssignedDate: null,
      taskCompletedDate: null,
      taskId: null,
      isDirectAddApprovalLink: false,
      taskFiles: [],
      fromButton: false,
      isLoadingLocal: false,
      groupId: null,
      // isLoading: false,
      inValidElements: [],
      inValidSections: [],
      leaveConfirm: false,
      initialResults: [],
      riskData: {
        percentage: null,
        risk: null,
        rating: null,
        color: null,
      },
      // progress bar
    };
  },
  props: {
    formData: Object,
    isLoadingForm: Boolean,
    isDisabled: Number
  },

  mounted () {
    setTimeout( () => {
      this.setFormData();
    }, 150 );
  },
  created () {
    EventBus.$on( "onDirectAddApprovalLink", ( value ) => {
      this.isDirectAddApprovalLink = true;
    } );
  },
  beforeDestroy () { },

  beforeRouteLeave ( to, from, next ) {
    if ( this.$route.name == "userform" ) {
      // console.log("leaving route..");
      if ( this.fromButton || this.$store.state.form1.isReadOnly == 1 ) {
        next();
      } else {
        // this.$bvModal.show("modal-leave");
        let employeeIdActive = localStorage.getItem( "employeeId" );
        if(employeeIdActive) {
          const answer = window.confirm( this.$t( "formLeaveAlertMessage" ) );
          if ( answer ) {
            // console.log("-------clear userFormSubmitArray--------- ");
            this.$store.state.userFormSubmitArray = [];
            this.$store.state.getUserFormSubmitArray = [];
            this.onResetLocalData();
            next();
          } else {
            next( false );
          }
        } else {
          next();
        }
      }
    } else {
      next();
    }
  },

  computed: {
    ...mapGetters( {
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),

    ...mapState( {
      userFormSubmitArray: "userFormSubmitArray",
      form: "form1",
      validFields: "validFields",
      rightAlign: "rightAlign",
      progressValue: "progressValue",
      progressMaxValue: "progressMaxValue",
    } ),
  },

  watch: {
    selectedLanguage ( lang ) {
      this.updateTitles( lang );
    },
  },

  methods: {
    ...mapActions( ["setLanguage"] ),
    ...mapMutations( ["TOGGLE_LOADER"] ),
    ...mapMutations( ["UPDATE_FORM"] ),

    setFormData () {
      // this.form = this.formData;
    },

    makeToast () {
      const h = this.$createElement;
      const vNodesMsg = h( "p", { class: ["text-center", "mb-0"] }, [
        h( "b-spinner", { props: { type: "grow", small: true } } ),
        // " We are generating your PDF... ",
        this.$t( "toast.generatePDF" ),
        h( "b-spinner", { props: { type: "grow", small: true } } ),
      ] );
      this.$bvToast.toast( [vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 5000,
      } );
    },

    onResetLocalData () {
      localStorage.removeItem( "taskId" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "examAttemptId" );
      localStorage.removeItem( "tempForm" );
      localStorage.removeItem( "activeFormId" );
      localStorage.removeItem( "userConsent" );
      this.$store.state.registerData = {};
      this.$store.state.progressValue = 0;
      this.$store.state.progressMaxValue = 0;
    },

    updateTitles ( lang ) {
      // console.log("lang", lang);
      const dd = this.$store.state.userFormSubmitArray;
      dd.map( ( a ) => {
        // let returnValue = { ...a };
        return ( a.language = lang );
        // return returnValue;
      } );
    },

    onValidateSubmit () {
      EventBus.$emit( "onSubmitEndUserForm", "form submit" );
      this.selectForm.amount = null;
      this.selectForm.approvalStatus = null;
      this.getInvalidFields();
      this.checkForInValidFields();
    },

    setFieldsValue () {
      let selectedAmount = null;
      let amountFieldsIndex = this.$store.state.userFormSubmitArray.findIndex(
        ( x ) => x.elementTitle.english.includes( 'Amount in USD' )
      );
      if ( this.$store.state.userFormSubmitArray[amountFieldsIndex] && this.$store.state.userFormSubmitArray[amountFieldsIndex].elements && this.$store.state.userFormSubmitArray[amountFieldsIndex].elements[0] && this.$store.state.userFormSubmitArray[amountFieldsIndex].elements[0].postValue ) {
        selectedAmount = this.$store.state.userFormSubmitArray[amountFieldsIndex].elements[0].postValue;
      }
      this.selectForm.amount = selectedAmount ? parseInt( selectedAmount ) : null;
      if ( this.selectForm.amount ) {
        let selectedDataAttributes = this.$store.state.userFormSubmitArray[amountFieldsIndex].dataAttributes ? this.$store.state.userFormSubmitArray[amountFieldsIndex].dataAttributes : [];
        if ( selectedDataAttributes && selectedDataAttributes != undefined && selectedDataAttributes.length != 0 ) {
          let minAmountIndexAttribute = selectedDataAttributes.findIndex(
            ( x ) => x.dataAttributeKey == "min_amount"
          )
          let minAmount = selectedDataAttributes[minAmountIndexAttribute].dataAttributeValue ? selectedDataAttributes[minAmountIndexAttribute].dataAttributeValue : null;

          let maxAmountIndexAttribute = selectedDataAttributes.findIndex(
            ( x ) => x.dataAttributeKey == "max_amount"
          )
          let maxAmount = selectedDataAttributes[maxAmountIndexAttribute].dataAttributeValue ? selectedDataAttributes[maxAmountIndexAttribute].dataAttributeValue : null;

          let approvalStatusIndexAttribute = selectedDataAttributes.findIndex(
            ( x ) => x.dataAttributeKey == "approval_status"
          )
          let approvalStatus = selectedDataAttributes[approvalStatusIndexAttribute].dataAttributeValue ? selectedDataAttributes[approvalStatusIndexAttribute].dataAttributeValue : null;

          if ( maxAmount || minAmount || approvalStatus ) {
            this.checkAmountField( minAmount, maxAmount, approvalStatus );
            return;
          }
        }
      }
      this.checkFieldsConditions();
    },
    checkFieldsConditions () {
      this.$store.state.userFormSubmitArray.forEach( formData => {
        if ( !this.selectForm.approvalStatus ) {
          if ( formData && formData.elements && formData.elements[0] && formData.elements[0].custom_values && formData.elements[0].custom_values[0] ) {
            let approvalStatus = formData.elements[0].custom_values[0].approval_status ? formData.elements[0].custom_values[0].approval_status : null;
            let minAmount = formData.elements[0].custom_values[0].min_amount ? formData.elements[0].custom_values[0].min_amount : null;
            let maxAmount = formData.elements[0].custom_values[0].max_amount ? formData.elements[0].custom_values[0].max_amount : null;
            this.checkAmountField( minAmount, maxAmount, approvalStatus );
          }
        }
      } );
      if ( !this.selectForm.approvalStatus ) {
        this.selectForm.approvalStatus = 1;
        this.onReviewSubmit();
      }
    },

    checkAmountField ( minAmount, maxAmount, approvalStatus ) {
      if ( minAmount && minAmount.length == 0 ) {
        minAmount = null;
      }
      if ( maxAmount && maxAmount.length == 0 ) {
        maxAmount = null;
      }
      if ( approvalStatus && approvalStatus.length == 0 ) {
        approvalStatus = null;
      }
      let intMinAmount = minAmount ? parseInt( minAmount ) : null;
      let intMaxAmount = maxAmount ? parseInt( maxAmount ) : null;

      if ( !maxAmount && !minAmount && approvalStatus ) {
        this.selectForm.approvalStatus = approvalStatus;
        this.onReviewSubmit();
      } else if ( maxAmount && minAmount && approvalStatus ) {
        if ( intMinAmount <= this.selectForm.amount && this.selectForm.amount <= intMaxAmount ) {
          this.selectForm.approvalStatus = approvalStatus;
          this.onReviewSubmit();
        } else {
          this.selectForm.approvalStatus = 1;
          this.onReviewSubmit();
        }
      }
    },

    checkForInValidFields () {
      let isValid = false;
      outerLoop: for ( let i = 0; i < this.$store.state.form1.formSection.length; i++ ) {
        for ( let x = 0; x < this.$store.state.form1.formSection[i].formElements.length; x++ ) {
          if (
            this.$store.state.form1.formSection[i].formElements[x].isInValid
          ) {
            let inValidData = {
              elementId: this.$store.state.form1.formSection[i].formElements[x].id,
              sectionId: this.$store.state.form1.formSection[i].id,
            };
            EventBus.$emit( "OnInvalidFieldCatch", inValidData );
            this.showErrorToast = true;
            isValid = false;
            // console.log( "inValidElements", this.inValidElements );
            break outerLoop;
          }
          isValid = true;
        }
      }
      if ( isValid ) {
        this.setFieldsValue();
      }
    },

    getInvalidFields () {
      this.inValidElements = [];
      this.inValidSections = [];
      for ( let i = 0; i < this.$store.state.form1.formSection.length; i++ ) {
        for ( let x = 0; x < this.$store.state.form1.formSection[i].formElements.length; x++ ) {
          if ( this.$store.state.form1.formSection[i].formElements[x].isInValid ) {
            this.inValidElements.push( this.$store.state.form1.formSection[i].formElements[x] );
          }
        }
      }
    },

    onReviewSubmit () {
      if ( this.$store.state.validFields ) {
        this.showErrorToast = false;
        this.$bvModal.show( "modal-1" );
      } else {
        this.showErrorToast = true;
      }
    },

    async onSubmit () {
      this.saveApproval();
    },
    makeToster ( tosterVarient, tosterMsg ) {
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },

    async saveApproval () {
      // let employeeId = localStorage.getItem( "employeeId" );
      let filesCount = 0;
      let form_data = this.$store.state.userFormSubmitArray;
      form_data.map( ( elementsData ) => {
        if (
          elementsData.elementInputType == "file"
        ) {
          filesCount = ( elementsData.elements ) ? ( ( elementsData.elements.length > 0 ) ? ( ( elementsData.elements[0] ) ? ( ( elementsData.elements[0].postValue ) ? ( elementsData.elements[0].postValue.length > 0 ? elementsData.elements[0].postValue.length : 0 ) : 0 ) : 0 ) : 0 ) : 0;
        }
      } );

      this.isLoadingData = true;
      let formData = {
        employee_id: localStorage.getItem( "employeeId" ),
        currency_id: 1,
        amount: this.selectForm.amount,
        meta_data: { filesCount: filesCount },
        form_data: this.$store.state.userFormSubmitArray,
        status: this.selectForm.approvalStatus,
        approval_id: this.$route.params.approvalId,
        approval_type_id: this.selectForm.approvalType ? this.selectForm.approvalType.value : null,
        approval_type: this.selectForm.approvalType ? ( this.selectForm.approvalType.title ? ( this.selectForm.approvalType.title[this.selectedLanguage] ? this.selectForm.approvalType.title[this.selectedLanguage] : (this.formData.formTitle ? this.formData.formTitle[this.selectedLanguage || "english"] : null) ) : (this.formData.formTitle ? this.formData.formTitle[this.selectedLanguage || "english"] : null) ) : (this.formData.formTitle ? this.formData.formTitle[this.selectedLanguage || "english"] : null),
        user_id: localStorage.getItem( "userId" )
      };
      try {
        this.submiting = true;
        let result = await HTTP( "post", "api/v1/approvals/update", formData );
        this.submiting = false;
        this.responseSuccess = true;
        if ( result.data.status != 1 ) {
          this.makeToster( "danger", result.data.message );
        } else if ( result.data.status == 1 ) {
          // this.makeToster( "success", result.data.message );
          this.fromButton = true;
          this.$bvModal.show( "modal-2" );
          // let url = (this.isDirectAddApprovalLink) ? '/dashboard' : '/employee-approvals';
          // this.$router.replace(url);
        }
        this.isLoadingData = false;
      } catch ( err ) {
        this.submiting = false;
        this.isLoadingData = false;
        this.responseSuccess = false;
        return [err];
      }
    },

    onScrollClick ( index ) {
      // console.log("index", index);
      let id = "section_" + index;
      this.currentSectionIndex = index;
      document.getElementById( id ).scrollIntoView( { behavior: "smooth" } );
    },
  },
};
</script>
<style scoped>
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(calc(100vh - 367px));
  /* height:400px */
}
.selectPicket {
  width: 350px;
}
</style>
<style>
/* .v-select .vs__dropdown-menu {
  height: 230px;
} */
.style-chooser .vs__dropdown-menu {
  height: 230px !important;
}
</style>
